import React from "react";
import ReactDOM from "react-dom";
import "../css/EmailDetailsModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

// Read-only detail view for one Communication History row. Follows this codebase's
// existing custom-modal pattern (overlay div + role="dialog" panel) rather than
// Bootstrap's JS-driven modal — see AssignParticipantsModal.js for the same shape.
const EmailDetailsModal = ({ record, statusSummary, onClose }) => {
  if (!record) return null;

  const formatDate = (value) =>
    value
      ? new Date(value).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
      : "-";

  // Portal straight to document.body — position: fixed only escapes the viewport if no
  // ancestor has a transform/filter/perspective. ParticipantEdit.js has several (the
  // sliding tab-pill animation among them), which was pinning this modal to that
  // ancestor's box instead of the real screen when opened from that page.
  return ReactDOM.createPortal(
    <div className="email-modal-overlay" role="presentation" onMouseDown={onClose}>
      <div
        className="email-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="email-modal-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header className="email-modal-header">
          <div className="email-modal-header-text">
            <h2 id="email-modal-title" className="email-modal-title">{record.subject || "-"}</h2>
            <p className="email-modal-subtitle">
              <span className="email-modal-subtitle-label">To</span> {record.email || "-"}
            </p>
          </div>
          <button type="button" className="email-modal-close" onClick={onClose} aria-label="Close">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>

        <div className="email-modal-body">
          {statusSummary && (
            <div className="email-modal-status-card">
              <span className={`status-badge ${statusSummary.className}`}>{statusSummary.badge}</span>
              <span>{statusSummary.text}</span>
            </div>
          )}

          <div className="email-modal-section">
            <dl className="email-modal-meta">
              <dt>From Name</dt>
              <dd className={!record.from_name ? "email-modal-empty-value" : undefined}>{record.from_name || "Not recorded"}</dd>
              <dt>From Email</dt>
              <dd className={!record.from_email ? "email-modal-empty-value" : undefined}>{record.from_email || "Not recorded"}</dd>
              <dt>Reference</dt>
              <dd className={!record.referenceId ? "email-modal-empty-value" : undefined}>{record.referenceId || "None"}</dd>
              <dt>Sent At</dt>
              <dd>{formatDate(record.sent_at)}</dd>
            </dl>
          </div>

          <div className="email-modal-section">
            <p className="email-modal-section-label">Attachments</p>
            {record.attachments?.length > 0 ? (
              <div className="email-modal-attachments">
                {record.attachments.map((f, i) => (
                  <a
                    key={i}
                    href={f.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="email-modal-attachment-chip"
                  >
                    {f.filename || `File ${i + 1}`}
                  </a>
                ))}
              </div>
            ) : (
              <p className="email-modal-empty">No attachments</p>
            )}
          </div>

          <div className="email-modal-section">
            <p className="email-modal-section-label">Message</p>
            <div className="email-modal-message-body" dangerouslySetInnerHTML={{ __html: record.body }} />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EmailDetailsModal;
